import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
/*import { getMesNumero, getMesNombre } from '../../mixins/helpers';*/

const state = {
    proveedorId: 0,
    
    id: 0,
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    cuentaNumero: '',
    cbu: '',
    cbuAlias: '',
    rowVersion: null,

    bancoPaisId: 0,

    proveedorBancoCuentaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_CUENTA' (state, params) {
        state.id = params.id;
        state.proveedorId = params.proveedorId;

        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.cuentaNumero = '';
        state.cbu = '';
        state.cbuAlias = '';
        state.rowVersion = null;

        state.bancoPaisId = 0;
    },
    'SET_BANCO_CUENTA' (state, bancoCuenta) {
        state.bancoId = bancoCuenta.banco? bancoCuenta.banco.id : 0;
        state.banco = bancoCuenta.banco;
        state.bancoNombre = bancoCuenta.banco? bancoCuenta.banco.nombre.trim() : null;
        state.cuentaNumero = bancoCuenta.cuentaNumero.trim();
        state.cbu = bancoCuenta.cbu;
        state.cbuAlias = bancoCuenta.cbuAlias;
        state.rowVersion = bancoCuenta.rowVersion;

        state.bancoPaisId = bancoCuenta.banco? bancoCuenta.banco.paisId : 0;
    },

    'INICIALIZAR_DATOS'(state) {
        state.proveedorBancoCuentaDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.proveedorBancoCuentaDatos = params.proveedorBancoCuentaDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CUENTA', params);

            if (params.id) {
                if (params.id != 0) {
                    apiAxios.get('proveedoresbancoscuentas/' + params.id + '/abm' ) 
                    .then(res => {
                        commit('SET_BANCO_CUENTA', res.data);

                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
                } else {
                    resolve();    
                }
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let bancoCuenta= {
                proveedorId: state.proveedorId,
                bancoId: state.bancoId,
                banco: state.banco,
                cuentaNumero: state.cuentaNumero.toUpperCase().trim(),
                cbu: state.cbu.trim(),
                cbuAlias: state.cbuAlias.toUpperCase().trim(),
            }

            let url = 'proveedoresbancoscuentas';
            if (state.id != 0) {
                url += "/" + state.id;
                bancoCuenta.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, bancoCuenta)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    delete ( { }, bancoCuentaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('proveedoresbancoscuentas/' + bancoCuentaId + '/delete')
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    getDatos ( { commit }, bancoCuentaId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (bancoCuentaId) {
                if (bancoCuentaId != 0) {
                    apiAxios.get('proveedoresBancosCuentas/' + bancoCuentaId ) 
                    .then(res => {

                        let proveedorBancoCuentaDatos = [
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                            { 'nombre': 'cuentaNumero', 'campo': 'Nro.Cuenta', 'valor': res.data.cuentaNumero, 'formato': '' },
                            { 'nombre': 'cbu', 'campo': 'CBU', 'valor': res.data.CBU, 'formato': '' },
                            { 'nombre': 'cbuAlias', 'campo': 'CBU Alias', 'valor': res.data.cbuAlias, 'formato': '' },
                        ];
                        
                        let params = {
                            proveedorBancoCuentaDatos
                        };

                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
                }
            } 
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}